import { useRef, useState, type FormEvent } from 'react';
import { api, type Session } from '../shared/api';
import { ErrorMessage, Field } from '../shared/ui';
import { LanguageSelector } from '../shared/LanguageSelector';
import { useI18n } from '../shared/i18n';

export function Login({ onLogin, resumeCode }: { onLogin: (session: Session) => void; resumeCode?: string }) {
  const { t } = useI18n();
  const [login, setLogin] = useState(resumeCode ?? '');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>();
  const passwordInput = useRef<HTMLInputElement>(null);
  async function submit(event: FormEvent) {
    event.preventDefault(); setBusy(true); setError(undefined);
    try {
      await api('/api/auth/login', { method: 'POST', body: JSON.stringify({ login, password }) });
      setPassword('');
      const session = await api<Session>('/api/auth/session');
      if (!session.authenticated || !session.user) throw new Error('Die Anmeldung konnte nicht bestätigt werden.');
      if (resumeCode && session.user.code !== resumeCode) throw new Error('Bitte melden Sie sich mit dem bisherigen Benutzer an.');
      onLogin(session);
    } catch (err) { setError(err); passwordInput.current?.focus(); }
    finally { setBusy(false); }
  }
  return <main className="login-page"><form className="login-form" onSubmit={submit}>
    <header>KOMBINAS OFIS <span>{t('Anmeldung')}</span></header>
    <div className="login-content">
      <LanguageSelector />
      <p>{t(resumeCode ? 'Sitzung abgelaufen. Melden Sie sich erneut an; Ihre geöffneten Eingaben bleiben erhalten.' : 'Bitte mit vorhandenem Verkäufer-Code oder Namen anmelden.')}</p>
      <ErrorMessage error={error} />
      <Field label="Code / Name"><input value={login} onChange={e => setLogin(e.target.value)} autoComplete="username" autoFocus={!resumeCode} readOnly={!!resumeCode} required disabled={busy} /></Field>
      <Field label="Passwort"><input ref={passwordInput} type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" autoFocus={!!resumeCode} disabled={busy} /></Field>
      <button className="primary" type="submit" disabled={busy}>{t(busy ? 'Anmelden …' : 'Anmelden')}</button>
    </div>
  </form></main>;
}
